<template>
  <ul v-if="files?.length" class="files" :class="{ 'files--grid': grid }">
    <li v-for="(file, i) in files" :key="i" class="files__item">
      <VFileItem
        :is-download="isDownload"
        :file="file"
        :index="i"
        :show-delete="showDelete"
        :icon-name-btn-delete="iconNameBtnDelete"
        @on-delete="onDelete" />
    </li>
  </ul>

  <p v-else class="mt-30">Файлы отсутствуют</p>
</template>

<script>
import VFileItem from '@/components/list/FileList/VFileItem'
export default {
  components: {
    VFileItem,
  },
  props: {
    files: {
      type: [Array, null],
      required: true,
    },
    grid: {
      type: Boolean,
      required: false,
      default: false,
    },
    showDelete: {
      type: Boolean,
      required: false,
      default: false,
    },
    isDownload: {
      type: Boolean,
      required: false,
      default: true,
    },
    iconNameBtnDelete: {
      type: String,
      required: false,
      default: 'DeleteFile',
    },
  },
  emits: ['onDelete'],
  setup(props, { emit }) {
    const onDelete = (fileId, file) => {
      emit('onDelete', fileId, file)
    }

    return {
      onDelete,
    }
  },
}
</script>
